/**
 * InternalToolGuard — app_admin only, but renders a 404 instead of redirecting
 * so internal tools stay invisible to everyone else.
 */
import { ReactNode } from "react";
import { RequireRole } from "./RequireRole";

export function InternalToolGuard({ children }: { children: ReactNode }) {
  return (
    <RequireRole allowedRoles={["app_admin"]} onDenied="notfound">
      {children}
    </RequireRole>
  );
}

export default InternalToolGuard;
